// @ts-nocheck
import axios from 'axios';
import { create } from 'zustand';
import { API_URL } from '../configs';
import { toastTypes } from '../enums';
import getRoot from './root';

let emailRef = null;

const useAdminStore = create((set, get) => ({
  clientData: {},
  // Kept as an action rather than a get/set accessor pair: zustand's set()
  // spreads state into a new object, which would freeze an accessor into a
  // plain data property after the first update.
  setEmailRef: (el) => { emailRef = el; },

  clearDataCache: () => {
    localStorage.removeItem('summaryData');
    localStorage.removeItem('summaryDataPathFilter');
    localStorage.removeItem('summaryDataDomainFilter');
    localStorage.removeItem('summaryDataTimeSpan');
    localStorage.removeItem('summaryDataCachedDate');
  },

  spoofClient: async (clientId = null) => {
    const root = getRoot();
    get().clearDataCache();
    const res = await axios.post(`${API_URL}/api/admin/spoof-client`, { clientId });
    if (res.data.success) {
      if (clientId) localStorage.setItem('spoofed', '1');
      else localStorage.removeItem('spoofed');
      window.location.reload();
    } else {
      root.failure('Spoof failed for some reason...');
    }
  },

  reset: () => set({ clientData: {} }),

  getClientData: async () => {
    try {
      const [clientInfoRes, clientStatsRes] = await Promise.all([
        axios.get(`${API_URL}/api/admin/client-list/`),
        axios.get(`${API_URL}/api/admin/overview-stats/`),
      ]);
      const clientInfo = clientInfoRes.data.clients || {};
      const clientStats = clientStatsRes.data.data || [];

      Object.keys(clientInfo).forEach((clientId) => {
        const match = clientStats.find((s) => s.client_id === clientId);
        if (match) {
          clientInfo[clientId].formsStarted = Number(match.t_form_start);
          clientInfo[clientId].abandons = Number(match.t_abandon);
          clientInfo[clientId].abandons_with_emails = Number(match.abandons_with_unique_emails);
        }
      });
      set({ clientData: clientInfo });
    } catch (err) {
      console.error(err);
    }
  },

  setClientStatus: async (clientId, statusTo) => {
    const root = getRoot();
    try {
      const res = await axios.post(`${API_URL}/api/um/${statusTo}`, { clientId });
      if (res.data.success) {
        root.success('Status changed successfully.', toastTypes.setClientStatus);
        root.clearToast(toastTypes.setClientStatus);
      } else {
        throw new Error();
      }
    } catch (e) {
      root.failure('Something went wrong...', toastTypes.setClientStatus);
    } finally {
      get().getClientData();
    }
  },

  downloadCaptures: async (clientId, company) => {
    const root = getRoot();
    try {
      const res = await axios.get(`${API_URL}/api/admin/captures/${clientId}`);
      if (res.data.success) {
        const list = [
          ['Name', 'Email', 'Capture Url'],
          ...res.data.captures.map((c) => [c.name, c.email, c.url]),
        ];
        const csv = list.map((row) => row.join(',')).join('\n');
        if (emailRef) {
          emailRef.href = URL.createObjectURL(new Blob([csv], { type: 'text/csv' }));
          emailRef.download = `captures_${company.replace(/ /gi, '_')}.csv`;
          emailRef.click();
        }
      } else {
        throw new Error();
      }
    } catch (err) {
      root.failure('Something went wrong...');
    }
  },
}));

export default useAdminStore;
